module.exports = __webpack_public_path__ + "img/quxue-2.c0d7dbac.jpg";